<template>
  <div class="message-queue-dialog">
    <el-dialog custom-class="with-title x-large" :title="title" :visible.sync="visible" :before-close="beforeClose">
      <message-queue-table v-if="isQueueTable" @change_tab="changeTab"></message-queue-table>
      <message-queue-create
        v-if="isQueueCreate"
        @change_tab="changeTab"
        :isChangeWithoutSubmit.sync="isChangeWithoutSubmit"
      ></message-queue-create>
      <message-queue-message-table v-if="isQueueMessageTable" @change_tab="changeTab"></message-queue-message-table>
      <message-queue-targets v-if="isMessageQueueTargets" @change_tab="changeTab"></message-queue-targets>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { mapActions } from 'pinia'
import { defineComponent } from 'vue'

import MessageQueueCreate from '@/client/features/twitter_instantwin_message/message_queue_create'
import MessageQueueMessageTable from '@/client/features/twitter_instantwin_message/message_queue_message_table'
import MessageQueueTable from '@/client/features/twitter_instantwin_message/message_queue_table'
import MessageQueueTargets from '@/client/features/twitter_instantwin_message/message_queue_targets'
import { useTwitterInstantwinQueueStore } from '@/client/store/useTwitterInstantwinQueueStore'

export default defineComponent({
  data() {
    return {
      tab: '',
      title: '一括配信メッセージの管理',
      visible: false,
      isChangeWithoutSubmit: false
    }
  },
  components: {
    MessageQueueTable,
    MessageQueueCreate,
    MessageQueueMessageTable,
    MessageQueueTargets
  },
  computed: {
    isQueueTable() {
      return this.tab === 'queue-list'
    },

    isQueueMessageTable() {
      return this.tab === 'queue-message-table'
    },

    isQueueCreate() {
      return this.tab === 'queue-create'
    },

    isMessageQueueTargets() {
      return this.tab === 'message-queue-targets'
    }
  },
  methods: {
    ...mapActions(useTwitterInstantwinQueueStore, ['reset']),

    /**
     * ダイアログをあく
     */
    open() {
      this.visible = true
      this.isChangeWithoutSubmit = false
      this.reset()
      this.tab = 'queue-list'
    },

    /**
     * Switch tab
     * @param {string} tab
     */
    changeTab(tab: string) {
      this.reset()
      this.tab = tab
    },

    /**
     * ダイアログ閉じるイベント
     */
    beforeClose(done: any) {
      if (!this.isChangeWithoutSubmit) {
        this.tab = ''
        return done()
      }

      const confirm = window.confirm('編集内容が保存されていません。ダイアログを閉じてよろしいですか?')

      if (!confirm) {
        return
      }

      this.tab = ''
      done()
    }
  }
})
</script>
